import { config } from "shared/data/configs";

export const serverConfig = {
  ...config,
  advertisement: {
    ...config.advertisement,
    googlePublisherTag: {
      ...config.advertisement.googlePublisherTag,
      lazyLoad: {
        fetchMarginPercent: Number(process.env.ADVERTISEMENT_LAZYLOAD_FETCH_MARGIN_PERCENT ?? 150),
        mobileScaling: Number(process.env.ADVERTISEMENT_LAZYLOAD_MOBILE_SCALING ?? 1.3),
        renderMarginPercent: Number(process.env.ADVERTISEMENT_LAZYLOAD_RENDER_MARGIN_PERCENT ?? 50),
      },
    },
  },
  aiSeo: {
    enabled: process.env.AI_SEO_ENABLED === "true",
    host: process.env.AI_SEO_API_HOST ?? "",
    minEntityId: Number(process.env.AI_SEO_MIN_ENTITY_ID ?? 3_360_000),
    timeoutMs: Number(process.env.AI_SEO_TIMEOUT_MS ?? 800),
    whitelistSectionIds: (process.env.AI_SEO_WHITELIST_SECTION_IDS ?? "")
      .split(",")
      .map(s => s.trim())
      .filter(Boolean),
  },
};
